module.exports = __webpack_public_path__ + "img/image-02.d9c3b5fb.webp";